import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
	domContentLoaded(() => {
		$('.js-slide-toggle').each((index, element) => {
			const $this = $(element);
			const $trigger = $this.find('.js-toggle-trigger');
			const $target = $this.find('.js-toggle-target');
			if ($this.hasClass('is-toggle-open')) {
				$target.show();
				$this.addClass('is-toggle-open');
			}
			$trigger.on('click', () => {
				if ($this.hasClass('is-toggle-open')) {
					$target.slideUp(300);
					$this.removeClass('is-toggle-open');
				} else {
					$target.slideDown(300);
					$this.addClass('is-toggle-open');
				}
				return false;
			})
		});
	});
};
